import React, { useState } from "react";
import { API } from "@/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Copy, Check, KeyRound } from "lucide-react";

export function CopyField({ label, value, testid }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); setDone(true); setTimeout(() => setDone(false), 1500); }
    catch { toast.error("Copie impossible — sélectionnez le texte manuellement"); }
  };
  return (
    <div className="border border-[#DEE2E6] bg-[#F8F9FA] p-3">
      <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96]">{label}</div>
      <div className="flex items-center gap-2 mt-1">
        <code className="font-mono text-sm break-all flex-1" data-testid={testid}>{value}</code>
        <Button size="sm" variant="outline" onClick={copy} data-testid={`${testid}-copy`} className="h-8 px-2 shrink-0">{done ? <Check className="h-3.5 w-3.5 text-[#059669]" /> : <Copy className="h-3.5 w-3.5" />}</Button>
      </div>
    </div>
  );
}

// Affiche une seule fois les identifiants (Device ID, clé API, secret) après création ou rotation.
export function CredentialsDialog({ creds, onClose }) {
  const curl = creds ? `curl "${API}/v1/ping" \\\n  -H "X-Device-Id: ${creds.device_id}" \\\n  -H "X-API-Key: ${creds.api_key}" \\\n  -H "X-API-Secret: ${creds.secret}"` : "";
  return (
    <Dialog open={!!creds} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl" data-testid="sc-credentials-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl font-black flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#FFD700]" /> {creds?.title || "Identifiants"} — {creds?.name}</DialogTitle></DialogHeader>
        {creds && (
          <div className="space-y-3">
            <div className="p-3 bg-[#FFF8E1] border border-[#FFD700] text-sm" data-testid="sc-credentials-warning">
              <b>Le secret n'est affiché qu'une seule fois.</b> Copiez ces trois valeurs dans votre appareil ou logiciel maintenant. En cas de perte, utilisez « Régénérer » pour obtenir de nouveaux identifiants.
            </div>
            <CopyField label="Device ID" value={creds.device_id} testid="sc-cred-device-id" />
            <CopyField label="Clé API (X-API-Key)" value={creds.api_key} testid="sc-cred-api-key" />
            <CopyField label="Secret (X-API-Secret)" value={creds.secret} testid="sc-cred-secret" />
            <div className="border border-[#0A0A0A] bg-[#0A0A0A] text-white p-3">
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#FFD700] mb-1">Exemple de test</div>
              <pre className="font-mono text-[11px] whitespace-pre-wrap break-all" data-testid="sc-cred-curl">{curl}</pre>
            </div>
            <Button onClick={onClose} className="w-full bg-[#0A0A0A] text-white" data-testid="sc-credentials-close">J'ai copié mes identifiants</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
